import {
  M8PartnerDTO,
  M8PartnerSortableField,
  M8PagedResponse,
  M8PaginationParams,
} from 'services/production/types';
import { createQueryString } from 'services/production/utils/createQueryString';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { customFetch } from 'utils/http';

export const getPartnersPage = async (
  params: M8PaginationParams<M8PartnerSortableField>
): Promise<M8PagedResponse<M8PartnerDTO>> => {
  const fetchURL = getM8AdminURL(
    `getPartnersPage?${createQueryString(params)}`
  );

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
